import logger from '../../../utils/logger';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import { BatchCycleStatus } from '../../../constants/BatchCycleStatus';
import { aeratorSwitch } from '../device-switches/aerator-switch';
import { screwSwitch } from '../device-switches/screw-switch';
import { vibratorSwitch } from '../device-switches/vibrator-switch';
import { beltSwitch } from '../device-switches/belt-switch';
import moment from 'moment';
import type { IBatchStore } from '../batch-store-types';
import { timerKey } from '../../../utils/timer-manager/timer-manager';

/**
 * Handle completion of jog mode decum discharge
 */
export const handleJogModeDecumComplete = (
  batchStore: IBatchStore,
  data: any,
  initialData: any,
) => {
  const { scale } = data;

  logger.log('finish jog mode decum discharge', data.material.code);

  aeratorSwitch(batchStore.rootStore, scale.aeratorId, false);
  screwSwitch(batchStore.rootStore, scale.screwId, false);
  vibratorSwitch(batchStore.rootStore, scale.vibratorId, false);

  let decumScalesStatusSize = 0;
  initialData.scales[scale.id].forEach((v: any, index: any) => {
    const ds = batchStore.getDeviceStatus(`${v.scale.id}-${v.material.code}`);
    if (initialData.uid === ds.uid && initialData.currentDrop === ds.currentDrop && ds.status === DeviceStatus.FINISH) {
      decumScalesStatusSize += 1;
      initialData.scales[scale.id][index].isFeedFinish = true;
    }
  });

  if (initialData.mix) {
    batchStore.batchDataForScale(scale.id, initialData);
  }

  if (decumScalesStatusSize === initialData.scales[scale.id].length && scale.parentScaleId) {
    batchStore.deviceStatus.set(scale.id, batchStore.getDeviceStatusDefault(scale));
    initialData.scales[scale.id].forEach((v: any) => {
      batchStore.deviceStatus.set(`${v.scale.id}-${v.material.code}`, batchStore.getDeviceStatusDefault(scale));
    });

    beltSwitch(batchStore.rootStore, scale.beltId, false);
  }

  if (scale.parentScaleId) {
    const nextScale = batchStore.devicesStore.getDeviceById(scale.parentScaleId);
    if (initialData.mix && batchStore.shouldWaitOnOtherScaleDischarge(nextScale)) {
      logger.log(`scale #${nextScale.id} ${nextScale.description} waiting on other scale to discharge`);
      return;
    }

    const nextScaleStatus = batchStore.getDeviceStatus(scale.parentScaleId);
    const nextScaleTarget = nextScaleStatus.target || 0;

    batchStore.checkDecumDischargeToNextScale(nextScale, nextScaleTarget, initialData, () => {

      const dischargeOpenDelay = (nextScale.dischargeOpenDelay || 2) * 1000;
      logger.log(`discharge open delay ${scale.description} -> ${nextScale.description}`, dischargeOpenDelay);

      const nextScaleStatus = batchStore.getDeviceStatus(scale.parentScaleId);
      batchStore.deviceStatus.set(scale.parentScaleId, {
        ...nextScaleStatus,
        status: DeviceStatus.FEED,
        startTime: moment().add(nextScale.dischargeOpenDelay, 'seconds'),
      });

      batchStore.timers.set(timerKey.dischargeToNextScaleDelay(nextScale.id), () => {

        const nextScaleStatus = batchStore.getDeviceStatus(scale.parentScaleId);
        batchStore.deviceStatus.set(scale.parentScaleId, {
          ...nextScaleStatus,
          status: DeviceStatus.WAIT_DISCH,
          startTime: null,
        });

        if (batchStore.isDischarge && !batchStore.discharging) {
          batchStore.timers.set(timerKey.dischargeToNextScaleTimer(), () => {
            if (batchStore.isDischarge && !batchStore.discharging) {
              batchStore.discharge();
            }
          }, 1000, 'Discharge to next scale');
        }

        if (!batchStore.isDischarge && batchStore.isReadyForFinalDischarge(initialData)) {
          batchStore.showReadyForDischarge(initialData);
          batchStore.context.onBatchCycle(BatchCycleStatus.LOAD_READY_FOR_DISCHARGE, batchStore.inputs, batchStore.outputs, batchStore.channels);
        }

        if (nextScale.parentScaleId) {
          batchStore.dischargeToNextScale(Object.assign(data, {scale: nextScale}), nextScale.parentScaleId, initialData.uid, initialData);
        } else {
          const runningData = Object.assign({}, { scaleId: nextScale.id, uid: initialData.uid,
            tId: initialData.tId, currentDrop: initialData.currentDrop });
          if (!batchStore.waitingForDischarge.find((v: any) => v.scaleId === nextScale.id && v.uid === initialData.uid)) {
            batchStore.waitingForDischarge.push(runningData);
          }
        }

      }, dischargeOpenDelay, `Discharge to next scale delay #${nextScale.id}`);

    });

  } else {
    if (decumScalesStatusSize === initialData.scales[scale.id].length) {
      logger.log('decum finish', scale.id);
      batchStore.onDischargeFinish(scale, initialData);
    }
  }
};
